import 'styles/datatable-mf.scss';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import WebFont from 'webfontloader';
import { MicroFrontendConstants } from 'common/Constants';
import { getUserPreferenceApi } from 'widgets/store/api/UserPreferenceApi';
import { getWidgetsApi } from 'widgets/store/api/DashboardWidgetsApi';
import { getKeyWorkOrderStatusesWidgetApi } from 'widgets/store/api/KeyWorkOrderStatusesWidgetApi';
import { WidgetsWrapper } from './WidgetsWrapper';
import { useAppDispatch } from 'widgets/store/WidgetsStore';

declare global {
    interface Window {
        __commentsRoot?: ReturnType<typeof ReactDOM.createRoot>;
        __widgetsRoot?: ReturnType<typeof ReactDOM.createRoot>;
        renderDashboardComments?: (id: string) => void;
        unmountDashboardComments?: () => void;
        renderDashboardWidgets?: (id: string) => void;
        unmountDashboardWidgets?: () => void;
        __nunitoLoaded?: boolean;
    }
}


export default function WidgetsMF() {
    const dispatch = useAppDispatch();

    const eventHandler = () => {
        dispatch(getUserPreferenceApi.util.resetApiState());
        dispatch(getWidgetsApi.util.resetApiState());
        dispatch(getKeyWorkOrderStatusesWidgetApi.util.resetApiState());
    };
    useEffect(() => {
        document.addEventListener(MicroFrontendConstants.OnParentLogout, eventHandler, false);

        if (!window.__nunitoLoaded) {
            WebFont.load({ google: { families: ['Nunito Sans:300,400,500,600,700'] } });
            window.__nunitoLoaded = true;
        }

        return () => {
            document.removeEventListener(MicroFrontendConstants.OnParentLogout, eventHandler);
        };
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        const head = document.head;
        const ourLinks = Array.from(
            document.querySelectorAll('link[rel="stylesheet"]')
        ).filter(l => (l.getAttribute('href') || '').includes('dashboard-mf'));
        ourLinks.forEach(l => head.appendChild(l));
    }, []);

    return (
        <div className="dashboard-mf">
            <WidgetsWrapper />
        </div>
    );
    // return <WidgetsWrapper />;
}
